<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>
                <span v-if="showParent">
                    <b-link :to="{name: 'crop-types.browse'}">
                        &ldquo;{{ cropType.name }}&rdquo;
                    </b-link>
                    /
                </span>
                <b-link :to="{name: 'variety-groups.browse', params: {cropTypeId: cropType.id}}">
                    &ldquo;{{ varietyGroup.name }}&rdquo;
                </b-link>
                /
                varieties
            </h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new variety"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Varieties</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields" :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">
                    <b-button @click="showEditDialog(row.item)" variant="secondary btn--icon" v-b-tooltip.hover="'Edit variety'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>
                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" :varietyGroup="varietyGroup" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" v-model="editingVariety" v-if="editingVariety" :variety="editingVariety" :varietyGroup="varietyGroup" />
    </div>
</template>

<script>
import findVarietyGroupQuery from '@views/Varieties/Browse/queryFindVarietyGroup.graphql';
import listVarietiesQuery from '@views/Varieties/Browse/queryListVarieties.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseVarieties',
  props: {
    varietyGroupId: {
      required: true,
    },
    canManage: true,
    showParent: true,
  },
  apollo: {
    varietyGroup: {
      query: findVarietyGroupQuery,
      update: data => data.findVarietyGroup,
      variables() {
        return {
          input: {
            id: this.varietyGroupId,
          },
        };
      },
    },
    varieties: {
      query: listVarietiesQuery,
      variables() {
        return {
          input: {
            variety_group_id: this.varietyGroupId,
            include_deleted: true,
          },
        };
      },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.varieties = data.filterVarieties.data;
          this.pagination.total = data.filterVarieties.meta.total;
        }
      },
    },
  },
  data() {
    return {
      varieties: [],
      varietyGroup: null,
      editingVariety: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: this.$tableDefaultPageSize,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'variety',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    cropType() {
      return this.varietyGroup.cropType;
    },
    tableData() {
      return (this.varieties || []).map(item => ({ ...item, }));
    },
  },
  methods: {
    showEditDialog(variety) {
      this.editingVariety = variety;
    },
    closeEditDialog() {
      this.editingVariety = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
